export default function DateRangeGreaterThanDirective($filter, utilitySevice) {
	'ngInject';

	return {
		require: 'ngModel',
		link: function(scope, elm, attrs, ctrl) {
			var validateDateRange = function(inputValue) {
				var fromDate = $filter('date')(attrs.dateRangeGreaterThan, 'short');
				var toDate = $filter('date')(inputValue, 'short');
				var isValid = utilitySevice.isValidMinDateRange(fromDate, toDate);
				ctrl.$setValidity('dateRangeGreaterThan', isValid);
				return inputValue;
			};

			ctrl.$parsers.unshift(validateDateRange);
			ctrl.$formatters.push(validateDateRange);
			attrs.$observe('dateRangeGreaterThan', function() {
				validateDateRange(ctrl.$viewValue);
			});
		}
	};
}
